import React from 'react';
import {SvgIcon} from '@mui/material';
import type {IconProps} from './types';

/** A two column layout where the left column fills the row. */
export const PanelLeftIcon: React.FC<IconProps> = (props: IconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M3 4H21V20H3V4ZM5 6V18H19V6H5Z" />
      <path d="M6 7H12V17H6V7Z" />
    </SvgIcon>
  );
};
